module.exports = __webpack_public_path__ + "static/media/faq.e109841f.png";